import {
  call,
  cancel,
  cancelled,
  delay,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import { getAvatar } from '../../features/avatar/avatarSlice'
import { getProfile, setProfile } from '../../features/userprofile/profileSlice'
import { RequestProfile } from '../requests/requestProfile'

export function* profileAPI() {
  const data = yield select()
  const user = data.user.userAccount.accountName
  console.log(user)
  return new Promise(async (resolve, reject) => {
    try {
      const avatars = await RequestProfile(user)
      resolve(avatars)
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveProfile() {
  try {
    const profileData = yield call(profileAPI)
    const { rows } = yield profileData
    console.log('PROFILE:', rows)
    const currentProfileObj = {
      avatar_asset_ids: rows[0].avatar_asset_ids,
      data: rows[0].avatar_ipfs,
    }
    console.log(currentProfileObj)
    yield put(
      setProfile({
        type: 'FETCHING_SUCCESS',
        currentAvatar: currentProfileObj,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setProfile({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setProfile({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* profileFlow() {
  while (true) {
    yield put(setProfile({ type: 'GET_PROFILE' }))
    const task = yield fork(resolveProfile)
    const action = yield take(['FETCHING_ERROR'])
    if (action.type === 'STOP_FETCHING') {
      yield cancel(task)
    }
  }
}
